<section class="jobs-section" id="jobs">
  <div class="jobs-container">
    <div class="">
      <div class="flex items-center justify-between gap-4">
        <h2 class="jobs-title">
          <span class="hidden md:inline">Featured Job <span class="brand-gradient-text">Opportunities</span></span>
          <span class="md:hidden brand-gradient-text">Jobs</span>
        </h2>
        <button class="btn-view-all group" routerLink="/jobs" data-testid="jobs-view-all">
          <span class="hidden sm:inline">View all</span><span class="sm:hidden">All</span>
          <svg aria-hidden="true" class="lucide lucide-arrow-right w-4 h-4" fill="none" stroke="currentColor"
            stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M5 12h14"></path>
            <path d="m12 5 7 7-7 7"></path>
          </svg>
        </button>
      </div>
    </div>
    
    <div class="relative group mt-8">
      <!-- Left Arrow (Desktop Only) -->
      <button (click)="scrollLeft()" *ngIf="!isAtStart && jobs.length > 0"
        class="arrow-btn hidden lg:flex absolute -left-12 top-1/2 -translate-y-1/2 -mt-3 z-10">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"></path></svg>
      </button>

      <div class="jobs-grid" #jobsGrid (scroll)="onGridScroll()">
      <ng-container *ngIf="isLoading">
        <div class="job-card loading-card-wrapper w-[95vw] sm:w-[50vw] md:w-full min-w-full flex justify-center items-center py-20 border-none shadow-none bg-transparent">
          <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600"></div>
        </div>
      </ng-container>

      <ng-container *ngIf="!isLoading && jobs.length === 0">
        <div class="job-card empty-card-wrapper w-[95vw] sm:w-[50vw] md:w-full min-w-full flex justify-center items-center py-20 border-none shadow-none bg-transparent">
          <div
            class="card h-100 p-4 w-full max-w-md mx-auto text-center"
            style="border-radius: 12px; border: 1px solid #e0e0e0; background: white;">
            <i class="bi bi-clock-history mb-3"
              style="font-size: 2rem; color: #a0a0a0;"></i>
            <h5 class="mb-2" style="font-size: 1.1rem; font-weight: 600;">
              More jobs coming soon
            </h5>
            <p class="text-muted" style="font-size: 0.9rem;"> We are actively adding more job opportunities.</p>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!isLoading && jobs.length > 0">
        <div *ngFor="let job of jobs; trackBy: trackByJobId" class="job-card cursor-pointer"
          (click)="handleCardClick($event)"
          [attr.data-testid]="'job-card-' + job.job_id">
          <div class="flex items-start justify-between">
            <div class="flex items-center gap-3">
              <div class="job-logo-box">
                <img [alt]="job.company_name" class="object-contain" loading="lazy"
                  [src]="job.company_logo || 'https://ui-avatars.com/api/?name=' + job.company_name" />
              </div>
              <div>
                <h3 class="job-title">{{ job.job_title }}</h3>
                <p class="job-company">{{ job.company_name }}</p>
              </div>
            </div>
            <div class="flex items-center gap-1 relative">
              <button class="btn-icon" (click)="shareJob(job, $event)">
                <svg aria-hidden="true" class="lucide lucide-share2 lucide-share-2 w-4 h-4" fill="none"
                  stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="5" r="3"></circle>
                  <circle cx="6" cy="12" r="3"></circle>
                  <circle cx="18" cy="19" r="3"></circle>
                  <line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line>
                  <line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line>
                </svg>
              </button>
              <button class="btn-icon" (click)="saveJob(job, $event)">
                <svg aria-hidden="true" class="lucide lucide-bookmark w-4 h-4" [attr.fill]="job.is_saved ? 'currentColor' : 'none'" stroke="currentColor"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"></path>
                </svg>
              </button>
              
              <!-- Custom Share Dropdown Fallback -->
              <div *ngIf="activeShareDropdown === job.job_id" class="absolute right-0 top-10 bg-white rounded-lg shadow-xl border border-slate-100 p-2 z-50 flex flex-col gap-1 w-48">
                <button class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left" (click)="shareTo('whatsapp', job, $event)">
                  <svg class="w-4 h-4 text-emerald-500" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"></path>
                  </svg> WhatsApp
                </button>
                <button class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left" (click)="shareTo('linkedin', job, $event)">
                  <svg class="w-4 h-4 text-blue-600" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"></path>
                  </svg> LinkedIn
                </button>
                <button class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left" (click)="shareTo('twitter', job, $event)">
                  <svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
                  </svg> X (Twitter)
                </button>
                <button class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left" (click)="shareTo('facebook', job, $event)">
                  <svg class="w-4 h-4 text-blue-700" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V7.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"></path>
                  </svg> Facebook
                </button>
                <button class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left" (click)="shareTo('telegram', job, $event)">
                  <svg class="w-4 h-4 text-sky-500" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm5.894-15.897L15.343 19.2c-.2.909-.74.114-1.25-.262l-3.473-2.55-1.68 1.616c-.18.173-.34.333-.7.333l.254-3.524 6.425-5.787c.28-.248-.061-.387-.435-.138L6.5 13.91l-3.418-1.071c-.742-.232-.756-.742.155-1.1L16.922 6.64c.633-.232 1.183.136.972 1.463z"></path>
                  </svg> Telegram
                </button>
                <button class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left" (click)="shareTo('email', job, $event)">
                  <svg class="w-4 h-4 text-gray-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="2" y="4" width="20" height="16" rx="2" ry="2"></rect>
                    <path d="M2 4l10 8 10-8"></path>
                  </svg> Email
                </button>
                <hr class="my-1 border-slate-100">
                <button [id]="'copy-btn-' + job.job_id" class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left" (click)="copyLink(job, $event)">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
                  </svg> Copy Link
                </button>
              </div>
            </div>
          </div>
          <div class="job-badges">
            <span class="badge-default">
              <svg aria-hidden="true" class="lucide lucide-briefcase w-3.5 h-3.5 text-indigo-400" fill="none"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                <rect height="14" rx="2" width="20" x="2" y="6"></rect>
              </svg>
              {{ job.experience_level || 'Fresher' }}
            </span>
            <span class="badge-primary">
              <svg aria-hidden="true" class="lucide lucide-laptop w-3.5 h-3.5" fill="none" stroke="currentColor"
                stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18 5a2 2 0 0 1 2 2v8.526a2 2 0 0 0 .212.897l1.068 2.127a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45l1.068-2.127A2 2 0 0 0 4 15.526V7a2 2 0 0 1 2-2z">
                </path>
                <path d="M20.054 15.987H3.946"></path>
              </svg>
              {{ job.work_mode }}
            </span>
          </div>
          <p class="job-location">
            <svg aria-hidden="true" class="lucide lucide-map-pin w-3.5 h-3.5 text-indigo-400" fill="none"
              stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
              </path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            {{ job.locations?.length ? job.locations.join(', ') : 'Not specified' }}
          </p>
          <div class="job-footer">
            <span class="job-meta">
              <span>{{ getTimeAgo(job.published_at || job.created_at) }}</span> &middot; <span>{{ job.number_of_openings
                || 1 }}</span> opening<span *ngIf="job.number_of_openings !== 1">s</span>
            </span>
            <button class="btn-apply group/btn" [attr.data-testid]="'job-apply-' + job.job_id"
              (click)="navigateToJob(job.job_id)">
              Apply Now
              <svg aria-hidden="true" class="lucide lucide-arrow-up-right w-4 h-4" fill="none" stroke="currentColor"
                stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M7 7h10v10"></path>
                <path d="M7 17 17 7"></path>
              </svg>
            </button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isFetchingMore">
        <div class="job-card w-[200px] flex justify-center items-center py-20 border-none shadow-none bg-transparent">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
        </div>
      </ng-container>
      </div>

      <!-- Right Arrow (Desktop Only) -->
      <button (click)="scrollRight()" *ngIf="(hasMoreJobs || !isAtEnd) && jobs.length > 0"
        class="arrow-btn hidden lg:flex absolute -right-12 top-1/2 -translate-y-1/2 -mt-3 z-10">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"></path></svg>
      </button>
    </div>
  </div>
</section>
